import React, { useEffect, useState } from 'react';
import { IntlProvider } from 'react-intl-next';
import { getMessagesForLocale } from '../utils/i18n-get-messages-for-locale';
export const IntlProviderWithResolvedMessages = ({
  children,
  locale
}) => {
  const [resolvedMessagesForLocale, setResolvedMessagesForLocale] = useState();
  useEffect(() => {
    const fetchMessageLocale = async () => {
      if (locale) {
        const messages = await getMessagesForLocale(locale);
        setResolvedMessagesForLocale(messages);
      }
    };
    fetchMessageLocale();
  }, [locale]);
  return /*#__PURE__*/React.createElement(IntlProvider, {
    locale: locale || 'en',
    defaultLocale: "en",
    messages: resolvedMessagesForLocale
  }, children);
};